module.exports = __webpack_public_path__ + "img/Return.6b7c6b50.svg";